import _ from 'lodash';
import { GameDayModel } from '../../models/gameday-model';
import { getLinkType } from '../../gameday/mappers/gameDay-orders.transfomations';
import { AccountReport } from '../models/account';

export function mapAccountAmountData(
  orders: GameDayModel.Order[]
): AccountReport[] {
  const resultMap: Map<string, AccountReport> = new Map<
    string,
    AccountReport
  >();
  const indexMap: Map<string, string[]> = new Map<string, string[]>();

  orders.forEach((order: GameDayModel.Order) => {
    let element: AccountReport;
    const key: string = generateKey(order);

    if (!resultMap.has(key)) {
      element = getAccountReportDefaultItem(order);
      const { name, moneyType } = element;

      resultMap.set(key, element);

      if (indexMap.has(name)) {
        indexMap.get(name).push(moneyType);
        indexMap.set(name, _(indexMap.get(name)).uniq().sort().value());
      } else {
        indexMap.set(name, [moneyType]);
      }
    }

    element = resultMap.get(key);

    if (order.priority === GameDayModel.OrderPriority.retail) {
      element.retailAmount += order.amount;
      element.total += order.amount;
    }
    if (order.priority === GameDayModel.OrderPriority.institutional) {
      element.institutionalAmount += order.amount;
      element.total += order.amount;
    }
    if (order.accountInfo.priority === GameDayModel.AccountPriority.stock) {
      element.total += order.amount;
    }
  });

  return fromMapToAccountsReportsData(resultMap, indexMap);
}

function fromMapToAccountsReportsData(
  resultMap: Map<string, AccountReport>,
  indexMap: Map<string, string[]>
): AccountReport[] {
  return Array.from(resultMap.keys(), (accountKey) => {
    const name = resultMap.get(accountKey).name;
    const indexMapElement = indexMap.get(name);
    const resultMapElement = resultMap.get(accountKey);

    if (indexMapElement.length > 1) {
      const index = indexMapElement.indexOf(resultMapElement.moneyType) + 1;
      const length = indexMapElement.length;
      resultMapElement.postfix = `(${index} of ${length})`;
    }

    return resultMapElement;
  });
}

function isAccountFullFilled(order: GameDayModel.Order): boolean {
  return !!order.firmId && !!order.accountName;
}

function getAccountReportDefaultItem(order: GameDayModel.Order): AccountReport {
  return {
    retailAmount: 0,
    institutionalAmount: 0,
    total: 0,
    name: getAccountName(order),
    postfix: '',
    moneyType: getMoneyType(order),
    linkType: getLinkType(order.accountInfo.priority)
  } as AccountReport;
}

function getMoneyType(order: GameDayModel.Order): string {
  if (isAccountFullFilled(order)) {
    return order.moneyType ? order.moneyType.name : '';
  }

  if (order.accountInfo.priority === GameDayModel.AccountPriority.undisclosed) {
    return GameDayModel.INSTITUTIONAL;
  }

  return getAccountNameByPriority(order);
}

function getAccountName(order: GameDayModel.Order): string {
  if (isAccountFullFilled(order)) {
    return order.accountName;
  }

  return getAccountNameByPriority(order);
}

function getAccountNameByPriority(order: GameDayModel.Order): string {
  return order.accountInfo.priority === GameDayModel.AccountPriority.stock
    ? GameDayModel.STOCK
    : order.accountInfo.name;
}

function generateKey(order: GameDayModel.Order): string {
  if (!isAccountFullFilled(order)) {
    return `${getAccountNameByPriority(order)}_${order.accountInfo.priority}`;
  }

  return order.moneyType && order.moneyType.code
    ? `${order.accountName}_${order.moneyType.code}`
    : order.accountName;
}
